import { render, staticRenderFns } from "./orderSend.vue?vue&type=template&id=65984c15&scoped=true"
import script from "./orderSend.vue?vue&type=script&lang=js"
export * from "./orderSend.vue?vue&type=script&lang=js"
import style0 from "./orderSend.vue?vue&type=style&index=0&id=65984c15&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65984c15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65984c15')) {
      api.createRecord('65984c15', component.options)
    } else {
      api.reload('65984c15', component.options)
    }
    module.hot.accept("./orderSend.vue?vue&type=template&id=65984c15&scoped=true", function () {
      api.rerender('65984c15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/retailer/order/refund/orderSend.vue"
export default component.exports